import type { SchemaField } from '../../../../types/schede'

interface LabelFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function LabelField({ field }: LabelFieldProps) {
  const text = field.label_text || field.label

  return (
    <div className="py-1">
      <p
        className="text-sm leading-relaxed"
        style={{ color: 'var(--color-text-primary)' }}
      >
        {text}
      </p>
      {field.help_text && (
        <p className="text-xs mt-0.5" style={{ color: 'var(--color-text-tertiary)' }}>
          {field.help_text}
        </p>
      )}
    </div>
  )
}
